import { render, staticRenderFns } from "./PerformerPreview.vue?vue&type=template&id=420d07c7&scoped=true"
import script from "./PerformerPreview.vue?vue&type=script&lang=js"
export * from "./PerformerPreview.vue?vue&type=script&lang=js"
import style0 from "./PerformerPreview.vue?vue&type=style&index=0&id=420d07c7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d07c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('420d07c7')) {
      api.createRecord('420d07c7', component.options)
    } else {
      api.reload('420d07c7', component.options)
    }
    module.hot.accept("./PerformerPreview.vue?vue&type=template&id=420d07c7&scoped=true", function () {
      api.rerender('420d07c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/PerformerPreview.vue"
export default component.exports